module.exports = __webpack_public_path__ + "static/media/kid18.4cd05665.png";